import React from 'react';
import { Helmet } from 'react-helmet';
import styled from 'styled-components';
import ReactMarkdown from 'react-markdown';
import SbEditable from 'storyblok-react';

import Navi from '../Navi/index.js';
import Footer from '../Footer/index.js';
import AttachmentsSection from './attachments_section.js';
import './press-release.scss';

const PressRelease = (props) => {
  const theme = props.blok.theme ?? 'dark';
  const naviBlok = { theme, phone_number: '18884651784' };
  const headerClasses = ['header'];
  headerClasses.push(`theme-${theme}`);
  const headerImage =
    props.blok.header_image && props.blok.header_image.filename
      ? props.blok.header_image.filename
      : '';

  return (
    <SbEditable content={props.blok}>
      <Helmet>
        <title>{props.blok.title} - Swell Energy</title>
        <meta name="description" content={props.blok.short_description} />
        <meta property="og:title" content={props.blok.title} />
        <meta property="og:description" content={props.blok.short_description} />
        <meta property="og:type" content="article" />
      </Helmet>
      <div className="press-release">
        <Navi blok={naviBlok}></Navi>
        <Wrapper
          bgImage={headerImage}
          className={headerClasses.join(' ')}
          bgOverlayOpacity={props.blok.disable_header_overlay ? 0 : 0.5}
        >
          <HeaderTitle>{props.blok.title}</HeaderTitle>
        </Wrapper>
        <div className="body">
          <ReactMarkdown children={props.blok.content} />
          {props.blok.attachments && props.blok.attachments.length > 0 && (
            <AttachmentsSection attachments={props.blok.attachments}></AttachmentsSection>
          )}
        </div>
        <Footer blok={{}}></Footer>
      </div>
    </SbEditable>
  );
};

export default PressRelease;

const Wrapper = styled.div`
  width: 100%;
  min-height: 50vh;
  background-image: ${(props) => (props.bgImage ? `url(${props.bgImage})` : 'none')};
  background-position: center center;
  background-size: cover;
  background-color: rgba(0, 0, 0, ${(props) => props.bgOverlayOpacity});
  background-blend-mode: overlay;
  display: flex;
  flex-direction: column;
  padding-top: 8rem;
  padding-bottom: 1rem;
`;

const HeaderTitle = styled.h1`
  max-width: 1200px;
  width: 80%;
`;
